export default "__VITE_ASSET__DAXH3Tai__"